export const templates = [
	{
		name: "europe011",
		state: {
			keep_basegrid_files: false,
			grid_root: 13,
			grid_level: 4,
			outfile: "europe011",
			icorotation: 0,
			icopole_lat: 90,
			icopole_lon: 0,
			domains: [
				{
					domain_id: 1,
					icontools: {
						parent_id: 0,
						region_type: 3,
						center_lat: -0.77,
						center_lon: -5.11,
						hwidth_lat: 25.025,
						hwidth_lon: 24.365,
						lrotate: true,
						pole_lat: 39.25,
						pole_lon: -162,
					},
					extpar: {
						iaot_type: 1,
						ilu_type: 1,
						ialb_type: 1,
						isoil_type: 1,
						itopo_type: 1,
						it_cl_type: 1,
						iera_type: 1,
						iemiss_type: 1,
						lradtopo: false,
						enable_cdnc: false,
						enable_edgar: false,
						radtopo_radius: 40000,
						enable_art: false,
						nhori: 24,
						l_use_corine: false,
						ilookup_table_lu: 1,
					}
				}
			]
		},
	},
	{
		name: "ICON-Global-Eu",
		state: {
			keep_basegrid_files: false,
			grid_root: 3,
			grid_level: 6,
			outfile: "ICON-Global-Eu",
			icorotation: 36.0,
			icopole_lat: 90,
			icopole_lon: 0,
			domains: [
				{
					domain_id: 1,
					icontools: {
						parent_id: 0,
						region_type: 1,
						lrotate: false,
						pole_lat: 90,
						pole_lon: -180,
					},
					extpar: {
						iaot_type: 1,
						ilu_type: 1,
						ialb_type: 1,
						isoil_type: 1,
						itopo_type: 3,
						it_cl_type: 2,
						iera_type: 2,
						iemiss_type: 1,
						lradtopo: false,
						enable_cdnc: false,
						enable_edgar: false,
						radtopo_radius: 40000,
						enable_art: false,
						nhori: 24,
						l_use_corine: false,
						ilookup_table_lu: 1,
					},
				},
				{
					domain_id: 2,
					icontools: {
						parent_id: 1,
						region_type: 3,
						center_lat: 50.0,
						center_lon: 19.5,
						hwidth_lat: 21.1,
						hwidth_lon: 44.2,
						lrotate: false,
						pole_lat: 90,
						pole_lon: -180,
					},
					extpar: {
						iaot_type: 1,
						ilu_type: 1,
						ialb_type: 1,
						isoil_type: 1,
						itopo_type: 3,
						it_cl_type: 2,
						iera_type: 2,
						iemiss_type: 1,
						lradtopo: false,
						enable_cdnc: false,
						enable_edgar: false,
						radtopo_radius: 40000,
						enable_art: false,
						nhori: 24,
						l_use_corine: false,
						ilookup_table_lu: 1,
					},
				}
			]

		},
	},
	{
		name: "ICON-D2",
		state: {
			keep_basegrid_files: false,
			grid_root: 19,
			grid_level: 6,
			outfile: "ICON-D2",
			icorotation: 36.0,
			icopole_lat: 90,
			icopole_lon: 0,
			domains: [
				{
					domain_id: 1,
					icontools: {
						parent_id: 0,
						region_type: 3,
						lrotate: true,
						pole_lat: 40,
						pole_lon: -170,
						center_lat: 0.85,
						center_lon: -1.0,
						hwidth_lat: 7.30,
						hwidth_lon: 6.65,
					},
					extpar: {
						iaot_type: 1,
						ilu_type: 1,
						ialb_type: 1,
						isoil_type: 1,
						itopo_type: 2,
						it_cl_type: 2,
						iera_type: 2,
						iemiss_type: 1,
						lradtopo: false,
						enable_cdnc: false,
						enable_edgar: false,
						radtopo_radius: 40000,
						enable_art: false,
						nhori: 24,
						l_use_corine: false,
						ilookup_table_lu: 1,
					},
				}
			]
		},
	},
]
